<template>
	<section class="view-ui-state-dots">
		<div class="dot" v-for="i in amount" v-bind:key="i" v-bind:class="{ active: i - 1 === activeIndex }"></div>
	</section>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Ui/State
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewUiStateDots extends ViewBase {
		/**
		 * @type number
		 */
		@Prop({ default: 5 })
		public amount!: number;

		/**
		 * @type number
		 */
		@Prop({ default: 0 })
		public activeIndex!: number;
	}
</script>

<style lang="scss">
	.view-ui-state-dots {
		--dot-size: 7px;

		.dot {
			background-color: var(--chalky-grey-2);
			border-radius: 50%;
			box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.7);
			cursor: pointer;
			display: inline-block;
			height: var(--dot-size);
			margin: 0 5px;
			transition: background-color 0.3s;
			width: var(--dot-size);

			&.active {
				background-color: var(--chalky-white);
			}
		}
	}
</style>
